<template>
  <div>
    <div v-show="!submitted">
      <ElForm
        label-position="top"
        require-asterisk-position="right"
        @submit.prevent
      >
        <ElAlert v-if="errorMsg" type="error" class="mb-5" show-icon>{{ errorMsg }}</ElAlert>

        <ElFormItem
          label="E-Mail Adresse"
          for="email"
          :error="errors.email?.[0]"
        >
          <ElInput
            id="email"
            v-model="form.email"
            type="email"
            required
          />
          <div class="w-full mt-2 text-gray-600 text-xs leading-4">
            Nach Absenden des Formulars {{ duzen('erhältst du', 'erhalten Sie') }} per E-Mail einen Link zum
            Einloggen im Finanzmanager. Bitte {{ duzen('prüfe dein', 'prüfen Sie Ihr') }} E-Mail-Postfach
            diesbezüglich. Bei diesem Verfahren ist kein Passwort notwendig.
          </div>
        </ElFormItem>

        <div class="mt-10 space-y-2">
          <AppButton
            native-type="submit"
            type="primary"
            class="w-full"
            size="large"
            :handler="loginHandler"
          >
            Absenden
          </AppButton>
          <div class="max-lg:hidden text-muted text-center">Oder</div>
          <AppButton
            type="primary"
            plain
            class="w-full"
            size="large"
            @click="emit('switch-to-password')"
          >
            Über Passwort anmelden
          </AppButton>
        </div>
      </ElForm>
    </div>

    <div
      v-show="submitted && !loading"
      class="space-y-5"
    >
      <ElAlert type="success" show-icon>
        Sofern {{ duzen('du einen Login besitzt', 'Sie einen Login besitzen') }}, haben wir
        {{ duzen('dir', 'Ihnen') }} eine Mail mit einem Zugangslink an <b>{{ form.email }}</b> verschickt.
        Bitte {{ duzen('überprüfe deinen', 'überprüfen Sie Ihren') }} Posteingang (sowie den Spamordner).
      </ElAlert>

      <AppButton
        type="primary"
        plain
        class="w-full"
        size="large"
        :handler="onReset"
      >
        Mit anderen Daten anmelden
      </AppButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import AppButton from '@/application/components/ui/AppButton.vue';
import { ElAlert, ElForm, ElFormItem, ElInput } from 'element-plus';

import { mailLogin } from '@/api/auth/authApi';
import { TrackEventCategory } from '@/application/utils/tracking/events';

import { useForm } from "@/api/lib/integration";
import { ref } from "vue";
import { useTagManager } from '@demv_systems/feu-tag-manager';
import { useBaseDataStore } from '@/user/store/baseDataStore.ts';

const emit = defineEmits(['switch-to-password']);

const { duzen } = useBaseDataStore();
const submitted = ref(false);

const { loading, form, errors, submit, reset, errorMsg } = useForm(
  mailLogin,
  { email: '' },
  () => { submitted.value = true },
);

const onReset = () => {
  reset();
  submitted.value = false;
};

const loginHandler = async () => {
  await submit();
  useTagManager().push({ event: TrackEventCategory.LOGIN_VIA_MAIL, action: 'anmelden' })
};
</script>
